/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import type { Provider, TransactionRequest } from "@ethersproject/providers";
import type { PromiseOrValue } from "../common";
import type {
  ILiquidityPool,
  ILiquidityPoolInterface,
} from "../ILiquidityPool";

const _abi = [
  {
    inputs: [
      {
        internalType: "contract IUnlimitedOwner",
        name: "unlimitedOwner_",
        type: "address",
      },
      {
        internalType: "contract IERC20Metadata",
        name: "collateral_",
        type: "address",
      },
      {
        internalType: "contract IController",
        name: "controller_",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "poolId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "assetAmount",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "shares",
        type: "uint256",
      },
    ],
    name: "AddedToPool",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "spender",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "Approval",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "user",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "CollectedEarlyWithdrawalFee",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "caller",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "assets",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "shares",
        type: "uint256",
      },
    ],
    name: "Deposit",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "liquidityPoolAdapter",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "DepositedFees",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "liquidityPoolAdapter",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "profit",
        type: "uint256",
      },
    ],
    name: "DepositedProfit",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint8",
        name: "version",
        type: "uint8",
      },
    ],
    name: "Initialized",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "liquidityPoolAdapter",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "loss",
        type: "uint256",
      },
    ],
    name: "PayedOutLoss",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "poolId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "lockTime",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "multiplier",
        type: "uint256",
      },
    ],
    name: "PoolAdded",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "poolId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "lockTime",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "multiplier",
        type: "uint256",
      },
    ],
    name: "PoolUpdated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "user",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "poolId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "poolShares",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "lpShares",
        type: "uint256",
      },
    ],
    name: "RemovedFromPool",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "Transfer",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "defaultLockTime",
        type: "uint256",
      },
    ],
    name: "UpdatedDefaultLockTime",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "earlyWithdrawalFee",
        type: "uint256",
      },
    ],
    name: "UpdatedEarlyWithdrawalFee",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "earlyWithdrawalTime",
        type: "uint256",
      },
    ],
    name: "UpdatedEarlyWithdrawalTime",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "minimumAmount",
        type: "uint256",
      },
    ],
    name: "UpdatedMinimumAmount",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "caller",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "receiver",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "assets",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "shares",
        type: "uint256",
      },
    ],
    name: "Withdraw",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "uint40",
        name: "lockTime_",
        type: "uint40",
      },
      {
        internalType: "uint16",
        name: "multiplier_",
        type: "uint16",
      },
    ],
    name: "addPool",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "address",
        name: "spender",
        type: "address",
      },
    ],
    name: "allowance",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "spender",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "approve",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "asset",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "availableLiquidity",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "user_",
        type: "address",
      },
    ],
    name: "canTransferLps",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "user_",
        type: "address",
      },
    ],
    name: "canWithdrawLps",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "controller",
    outputs: [
      {
        internalType: "contract IController",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "shares",
        type: "uint256",
      },
    ],
    name: "convertToAssets",
    outputs: [
      {
        internalType: "uint256",
        name: "assets",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "assets",
        type: "uint256",
      },
    ],
    name: "convertToShares",
    outputs: [
      {
        internalType: "uint256",
        name: "shares",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "decimals",
    outputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "spender",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "subtractedValue",
        type: "uint256",
      },
    ],
    name: "decreaseAllowance",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "defaultLockTime",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "assets_",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "minShares_",
        type: "uint256",
      },
    ],
    name: "deposit",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "assets_",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "minShares_",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "poolId_",
        type: "uint256",
      },
    ],
    name: "depositAndLock",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amount_",
        type: "uint256",
      },
    ],
    name: "depositFees",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "profit_",
        type: "uint256",
      },
    ],
    name: "depositProfit",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "earlyWithdrawalFee",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "earlyWithdrawalTime",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "spender",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "addedValue",
        type: "uint256",
      },
    ],
    name: "increaseAllowance",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "name_",
        type: "string",
      },
      {
        internalType: "string",
        name: "symbol_",
        type: "string",
      },
      {
        internalType: "uint256",
        name: "defaultLockTime_",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "earlyWithdrawalFee_",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "earlyWithdrawalTime_",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "minimumAmount_",
        type: "uint256",
      },
    ],
    name: "initialize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "lastDepositTime",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "shares_",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "poolId_",
        type: "uint256",
      },
    ],
    name: "lockShares",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "minimumAmount",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "pools",
    outputs: [
      {
        internalType: "uint40",
        name: "lockTime",
        type: "uint40",
      },
      {
        internalType: "uint16",
        name: "multiplier",
        type: "uint16",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "totalPoolShares",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "assets",
        type: "uint256",
      },
    ],
    name: "previewDeposit",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "shares",
        type: "uint256",
      },
    ],
    name: "previewMint",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "user_",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "poolId_",
        type: "uint256",
      },
    ],
    name: "previewPoolOf",
    outputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "poolId",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "totalPoolShares",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "unlockedPoolShares",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "totalShares",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "unlockedShares",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "totalAssets",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "unlockedAssets",
            type: "uint256",
          },
        ],
        internalType: "struct UserPoolDetails",
        name: "userPool",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "user_",
        type: "address",
      },
    ],
    name: "previewPoolsOf",
    outputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "poolId",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "totalPoolShares",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "unlockedPoolShares",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "totalShares",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "unlockedShares",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "totalAssets",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "unlockedAssets",
            type: "uint256",
          },
        ],
        internalType: "struct UserPoolDetails[]",
        name: "userPools",
        type: "tuple[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "shares",
        type: "uint256",
      },
    ],
    name: "previewRedeem",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "poolShares_",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "poolId_",
        type: "uint256",
      },
    ],
    name: "previewRedeemPoolShares",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "assets",
        type: "uint256",
      },
    ],
    name: "previewWithdraw",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "loss_",
        type: "uint256",
      },
    ],
    name: "requestLossPayout",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "totalAssets",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "totalSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "transfer",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "transferFrom",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "unlimitedOwner",
    outputs: [
      {
        internalType: "contract IUnlimitedOwner",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "poolId_",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "poolShares_",
        type: "uint256",
      },
    ],
    name: "unlockShares",
    outputs: [
      {
        internalType: "uint256",
        name: "lpAmount",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "defaultLockTime_",
        type: "uint256",
      },
    ],
    name: "updateDefaultLockTime",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "earlyWithdrawalFee_",
        type: "uint256",
      },
    ],
    name: "updateEarlyWithdrawalFee",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "earlyWithdrawalTime_",
        type: "uint256",
      },
    ],
    name: "updateEarlyWithdrawalTime",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "minimumAmount_",
        type: "uint256",
      },
    ],
    name: "updateMinimumAmount",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "poolId_",
        type: "uint256",
      },
      {
        internalType: "uint40",
        name: "lockTime_",
        type: "uint40",
      },
      {
        internalType: "uint16",
        name: "multiplier_",
        type: "uint16",
      },
    ],
    name: "updatePool",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "userPoolInfo",
    outputs: [
      {
        internalType: "uint256",
        name: "userPoolShares",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "unlockedPoolShares",
        type: "uint256",
      },
      {
        internalType: "uint128",
        name: "nextIndex",
        type: "uint128",
      },
      {
        internalType: "uint128",
        name: "length",
        type: "uint128",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "user_",
        type: "address",
      },
    ],
    name: "userWithdrawalFee",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "shares_",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "minOut_",
        type: "uint256",
      },
    ],
    name: "withdraw",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "poolId_",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "poolShares_",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "minOut_",
        type: "uint256",
      },
    ],
    name: "withdrawFromPool",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
] as const;

const _bytecode =
  "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";

type ILiquidityPoolConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: ILiquidityPoolConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class ILiquidityPool__factory extends ContractFactory {
  constructor(...args: ILiquidityPoolConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override deploy(
    unlimitedOwner_: PromiseOrValue<string>,
    collateral_: PromiseOrValue<string>,
    controller_: PromiseOrValue<string>,
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): Promise<ILiquidityPool> {
    return super.deploy(
      unlimitedOwner_,
      collateral_,
      controller_,
      overrides || {}
    ) as Promise<ILiquidityPool>;
  }
  override getDeployTransaction(
    unlimitedOwner_: PromiseOrValue<string>,
    collateral_: PromiseOrValue<string>,
    controller_: PromiseOrValue<string>,
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(
      unlimitedOwner_,
      collateral_,
      controller_,
      overrides || {}
    );
  }
  override attach(address: string): ILiquidityPool {
    return super.attach(address) as ILiquidityPool;
  }
  override connect(signer: Signer): ILiquidityPool__factory {
    return super.connect(signer) as ILiquidityPool__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): ILiquidityPoolInterface {
    return new utils.Interface(_abi) as ILiquidityPoolInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): ILiquidityPool {
    return new Contract(address, _abi, signerOrProvider) as ILiquidityPool;
  }
}
